// WCAG 2.x contrast ratio between two #rrggbb colours. Mirrors backend theme/Contrast.java.
export const AA_CONTRAST = 4.5;
/** The server refuses a theme below this; the UI stops saving too. */
export const MIN_CONTRAST = 3;

function channel(hex: string, start: number): number {
  const value = parseInt(hex.slice(start, start + 2), 16) / 255;
  return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
}

function luminance(hex: string): number {
  return 0.2126 * channel(hex, 1) + 0.7152 * channel(hex, 3) + 0.0722 * channel(hex, 5);
}

export function contrastRatio(a: string, b: string): number {
  const [light, dark] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return ((light ?? 0) + 0.05) / ((dark ?? 0) + 0.05);
}

/** Dark or white text, whichever reads better on the given background. */
export function readableOn(hex: string): string {
  return contrastRatio('#1b1410', hex) >= contrastRatio('#ffffff', hex) ? '#1b1410' : '#ffffff';
}
